// src/actions/kotakActions.js
import axios from "axios";
import {
  GET_ALL_KOTAK_RECORDS_REQUEST,
  GET_ALL_KOTAK_RECORDS_SUCCESS,
  GET_ALL_KOTAK_RECORDS_FAIL,
  CREATE_KOTAK_RECORD_REQUEST,
  CREATE_KOTAK_RECORD_SUCCESS,
  CREATE_KOTAK_RECORD_FAIL,
  UPDATE_KOTAK_RECORD_REQUEST,
  UPDATE_KOTAK_RECORD_SUCCESS,
  UPDATE_KOTAK_RECORD_FAIL,
  DELETE_KOTAK_RECORD_REQUEST,
  DELETE_KOTAK_RECORD_SUCCESS,
  DELETE_KOTAK_RECORD_FAIL,
  BULK_DELETE_KOTAK_RECORDS_REQUEST,
  BULK_DELETE_KOTAK_RECORDS_SUCCESS,
  BULK_DELETE_KOTAK_RECORDS_FAIL,
  IMPORT_KOTAK_RECORDS_REQUEST,
  IMPORT_KOTAK_RECORDS_SUCCESS,
  IMPORT_KOTAK_RECORDS_FAIL,
  EXPORT_KOTAK_RECORDS_REQUEST,
  EXPORT_KOTAK_RECORDS_SUCCESS,
  EXPORT_KOTAK_RECORDS_FAIL,
} from "../constants/KotakConstants";
import { logout } from "./userActions";

const baseUrl = process.env.REACT_APP_API_URL;

// Get all Kotak records
export const getAllKotakRecords =
  (queryParams = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_KOTAK_RECORDS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      // Parse and validate query parameters
      const params = new URLSearchParams(queryParams);
      const page = Math.max(1, parseInt(params.get("page")) || 1);
      const limit = Math.max(1, parseInt(params.get("limit")) || 10);
      const search = params.get("search") || "";
      const importDate = params.get("importDate") || "";
      const status = params.get("status") || "";
      const typeFilter = params.get("typeFilter") || "";
      const fosFilter = params.get("fosFilter") || "";
      const departmentFilter = params.get("departmentFilter") || "";

      // Rebuild clean query string
      let cleanQuery = `search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
      if (importDate) {
        cleanQuery += `&importDate=${encodeURIComponent(importDate)}`;
      }
      if (status) {
        cleanQuery += `&status=${encodeURIComponent(status)}`;
      }
      if (typeFilter) {
        cleanQuery += `&typeFilter=${encodeURIComponent(typeFilter)}`;
      }
      if (fosFilter) {
        cleanQuery += `&fosFilter=${encodeURIComponent(fosFilter)}`;
      }
      if (departmentFilter) {
        cleanQuery += `&departmentFilter=${encodeURIComponent(departmentFilter)}`;
      }

      console.log("Kotak API Call with params:", {
        search,
        page,
        limit,
        importDate,
        status,
        typeFilter,
        fosFilter,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/kotak?${cleanQuery}`,
        config,
      );
      dispatch({ type: GET_ALL_KOTAK_RECORDS_SUCCESS, payload: data });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: GET_ALL_KOTAK_RECORDS_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  };

// Create a new Kotak record
export const createKotakRecord = (recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CREATE_KOTAK_RECORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/kotak`, recordData, config);
    dispatch({ type: CREATE_KOTAK_RECORD_SUCCESS, payload: data });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: CREATE_KOTAK_RECORD_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Update a Kotak record
export const updateKotakRecord =
  (id, recordData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_KOTAK_RECORD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `${baseUrl}/kotak/${id}`,
        recordData,
        config,
      );
      dispatch({ type: UPDATE_KOTAK_RECORD_SUCCESS, payload: data });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: UPDATE_KOTAK_RECORD_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  };

// Delete a Kotak record
export const deleteKotakRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_KOTAK_RECORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/kotak/${id}`, config);
    dispatch({ type: DELETE_KOTAK_RECORD_SUCCESS, payload: id });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: DELETE_KOTAK_RECORD_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Bulk delete Kotak records
export const bulkDeleteKotakRecords = (ids) => async (dispatch, getState) => {
  try {
    dispatch({ type: BULK_DELETE_KOTAK_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/kotak/bulk-delete`,
      { ids },
      config,
    );
    dispatch({
      type: BULK_DELETE_KOTAK_RECORDS_SUCCESS,
      payload: { ids, deletedCount: data.deletedCount },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: BULK_DELETE_KOTAK_RECORDS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Import Kotak records
export const importKotakRecords = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: IMPORT_KOTAK_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/kotak/import`,
      formData,
      config,
    );
    dispatch({ type: IMPORT_KOTAK_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: IMPORT_KOTAK_RECORDS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Export Kotak records
export const exportKotakRecords = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPORT_KOTAK_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: "blob",
    };

    const { data } = await axios.get(`${baseUrl}/kotak/export`, config);
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Kotak_Export.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    dispatch({
      type: EXPORT_KOTAK_RECORDS_SUCCESS,
      payload: "Export completed successfully",
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: EXPORT_KOTAK_RECORDS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Add this function at the end of your actions file
export const syncKotakTaskStatus = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "SYNC_KOTAK_TASK_STATUS_REQUEST",
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/kotak/sync-status`,
      {},
      config,
    );

    dispatch({
      type: "SYNC_KOTAK_TASK_STATUS_SUCCESS",
      payload: data,
    });

    return data; // Return data including updatedRecords
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: "SYNC_KOTAK_TASK_STATUS_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

// Add this function at the end of your KotakAction.js file
export const getFieldExecutives =
  (search = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "GET_FIELD_EXECUTIVES_REQUEST",
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/kotak/field-executives?search=${encodeURIComponent(search)}`,
        config,
      );

      dispatch({
        type: "GET_FIELD_EXECUTIVES_SUCCESS",
        payload: data,
      });

      return data; // Return the data
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: "GET_FIELD_EXECUTIVES_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      throw error; // Throw error so it can be caught
    }
  };

export const getKotakFOS =
  (importDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "GET_FOS_REQUEST",
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      let url = `${baseUrl}/kotak/fos`;
      if (importDate) {
        url += `?importDate=${encodeURIComponent(importDate)}`;
      }

      const { data } = await axios.get(url, config);

      dispatch({
        type: "GET_FOS_SUCCESS",
        payload: data,
      });

      return data;
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: "GET_FOS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      throw error;
    }
  };

export const getKotakDepartments =
  (importDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "GET_DEPARTMENTS_REQUEST",
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      let url = `${baseUrl}/kotak/departments`;
      if (importDate) {
        url += `?importDate=${encodeURIComponent(importDate)}`;
      }

      const { data } = await axios.get(url, config);

      dispatch({
        type: "GET_DEPARTMENTS_SUCCESS",
        payload: data,
      });

      return data; // Return the data
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: "GET_DEPARTMENTS_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      throw error;
    }
  };
